module.exports = __webpack_public_path__ + "img/gate-rail-horizontal-left.ecd6f308.png";